"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiAlert = void 0;
const icons_1 = require("client/components/icons");
const callable_1 = require("client/components/ui/callable");
const react_1 = require("react");
const React = require("react");
require("./alert.less");
class UiAlert extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleClickDismiss = (event) => {
            callable_1.callable(this.props.onRequestDismiss)(event);
        };
    }
    render() {
        const { dismissable, message, padded, title, type = "error" } = this.props;
        const paddedClass = padded ? " ui-alert--padded" : "";
        return (React.createElement("div", { className: `ui-alert ui-alert--${type || "error"}${paddedClass}` },
            type === "error" && (React.createElement("div", { className: "icon" },
                React.createElement(icons_1.WarningIcon, { fill: "#e25810" }))),
            type === "warning" && (React.createElement("div", { className: "icon" },
                React.createElement(icons_1.WarningIcon, { fill: "#eeb20d" }))),
            React.createElement("div", { className: "text" },
                title && React.createElement("strong", null,
                    title,
                    ": "),
                message),
            dismissable && (React.createElement("a", { className: "dismiss", onClick: this.handleClickDismiss },
                React.createElement(icons_1.CloseIcon, { fill: "#e25810" })))));
    }
}
exports.UiAlert = UiAlert;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/alert/alert.tsx
// module id = 2126
// module chunks = 0 1 2